// extracted by mini-css-extract-plugin
export default {"button":"CreateNewFacility_button__tgT5q","plusIcon":"CreateNewFacility_plusIcon__Ic7eo","plusIconAvatar":"CreateNewFacility_plusIconAvatar__5WuQn"};